import { SectionHeading, slugify } from "./shared";

export default function UseCasesSection({ variant, content, images = [] }) {
  const useCases = content.useCases || [];
  if (!useCases.length) return null;

  if (variant === "timeline") {
    return (
      <section className="border-t border-line/70 bg-gradient-to-b from-[var(--gx-bg)] via-[#0B0B10] to-[var(--gx-bg)]" data-testid="usecase-section-timeline">
        <div className="max-w-[900px] mx-auto px-5 lg:px-10 py-20 lg:py-28">
          <SectionHeading eyebrow="In the home" title="How it lives, every day." />
          <div className="relative mt-16 pl-8 border-l border-line/60">
            {useCases.map((u, i) => (
              <div key={u.title} data-testid={`usecase-${slugify(u.title)}`} className="relative pb-14 last:pb-0">
                <div className="absolute -left-[38px] top-0 w-4 h-4 rounded-full bg-gold border-4 border-[var(--gx-bg)]" />
                <div className="text-[11px] tracking-[0.32em] uppercase text-mute mb-3">Scene · 0{i + 1}</div>
                <h3 className="font-display text-2xl tracking-tight max-w-[24ch]">{u.title}</h3>
                <p className="text-dim text-[14px] mt-3 leading-relaxed max-w-[64ch]">{u.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (variant === "alternating" && images.length) {
    return (
      <section className="border-t border-line/70" data-testid="usecase-section-alternating">
        <div className="max-w-[1300px] mx-auto px-5 lg:px-10 py-20 lg:py-28">
          <SectionHeading eyebrow="In the home" title="How it lives, every day." />
          <div className="mt-16 space-y-16">
            {useCases.map((u, i) => (
              <div key={u.title} data-testid={`usecase-${slugify(u.title)}`} className="grid md:grid-cols-2 gap-8 md:gap-14 items-center">
                <div className={`aspect-[4/3] rounded-2xl overflow-hidden border border-line/60 ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <img src={images[i % images.length]} alt={u.title} className="w-full h-full object-cover" />
                </div>
                <div className={i % 2 === 1 ? "md:order-1" : ""}>
                  <div className="text-[11px] tracking-[0.32em] uppercase text-mute mb-3">Scene · 0{i + 1}</div>
                  <h3 className="font-display text-2xl sm:text-3xl tracking-tight max-w-[20ch]">{u.title}</h3>
                  <p className="text-dim text-[14.5px] mt-4 leading-relaxed max-w-[52ch]">{u.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (variant === "numbered-steps") {
    return (
      <section className="border-t border-line/70 bg-[var(--gx-black)]" data-testid="usecase-section-numbered-steps">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20 lg:py-28">
          <SectionHeading eyebrow="In the home" title="How it lives, every day." />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
            {useCases.map((u, i) => (
              <div key={u.title} data-testid={`usecase-${slugify(u.title)}`} className="relative pt-2">
                <div className="font-display text-[88px] leading-none text-white/[0.06] absolute -top-6 -left-1 select-none">0{i + 1}</div>
                <div className="relative">
                  <h3 className="font-display text-2xl tracking-tight max-w-[18ch]">{u.title}</h3>
                  <p className="text-dim text-[14px] mt-4 leading-relaxed">{u.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="border-t border-line/70 bg-gradient-to-b from-[var(--gx-bg)] via-[#0B0B10] to-[var(--gx-bg)]" data-testid="usecase-section-cards">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20 lg:py-28">
        <SectionHeading eyebrow="In the home" title="How it lives, every day." />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {useCases.map((u, i) => (
            <div key={u.title} data-testid={`usecase-${slugify(u.title)}`} className="relative rounded-2xl border border-line bg-[var(--gx-surface)]/40 backdrop-blur-md p-8 overflow-hidden">
              <div className="text-[11px] tracking-[0.32em] uppercase text-mute mb-5">Scene · 0{i + 1}</div>
              <h3 className="font-display text-2xl tracking-tight max-w-[16ch]">{u.title}</h3>
              <p className="text-dim text-[14px] mt-4 leading-relaxed">{u.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
